export const SYSTEM_ERROR = "System error. Please try again later!";
